<div class="container">
  @switch (BANNER_TYPE[bannerType()].type) {
    <!-- SUCCESS BANNER-->
    @case (BANNER_MESSAGE_TYPE.SUCCESS) {
      <div class="background-success" [ngClass]="{ 'nav-open': drawerOpen }">
        <ion-icon class="icon" [src]="IMAGES.BANNER_SUCCESS"></ion-icon>
        <div class="text">{{ BANNER_TYPE[bannerType()].text }}</div>
        <ion-icon
          class="icon"
          [src]="IMAGES.CLOSE_BLACK"
          alt="close"
          (click)="clickExit()"
          onkeypress="clickExit()"
        ></ion-icon>
      </div>
    }
    <!-- CAUTION BANNER-->
    @case (BANNER_MESSAGE_TYPE.CAUTION) {
      <div class="caution-container">
        <div class="background-caution" [ngClass]="{ 'nav-open': drawerOpen }">
          <ion-icon class="icon" [src]="IMAGES.CAUTION"></ion-icon>
          <div class="text">{{ BANNER_TYPE[bannerType()].text }}</div>
          <ion-icon
            class="icon"
            [src]="IMAGES.CLOSE_BLACK"
            alt="close"
            (click)="clickExit()"
            onkeypress="clickExit()"
          ></ion-icon>
        </div>

        @if (
          commonUtils.fileUploadResponse().accepted !== 0 ||
          commonUtils.fileUploadResponse().rejected.length !== 0 ||
          commonUtils.fileUploadResponse().itemsNonProcessed.length !== 0
        ) {
          <div class="file-upload-response-container">
            <div class="results-from-upload">
              <div>
                @if (commonUtils.fileUploadResponse().uniqueUploadId) {
                  {{ FILE_UPLOAD_RESPONSE.DEVICE_NAME }} :
                  {{ commonUtils.fileUploadResponse().uniqueUploadId }}
                }
              </div>

              <div class="total-items-response">
                @if (commonUtils.fileUploadResponse().received) {
                  {{ FILE_UPLOAD_RESPONSE.NUMBER_OF_ROWS }} :
                  {{ commonUtils.fileUploadResponse().received }}
                }
              </div>

              <div class="packages-response">
                {{ FILE_UPLOAD_RESPONSE.ACCEPTED }} :
                {{ commonUtils.fileUploadResponse().accepted }}
                <br />

                {{ FILE_UPLOAD_RESPONSE.REJECTED }} :
                {{ commonUtils.fileUploadResponse().rejected.length }}
                <br />

                @if (commonUtils.fileUploadResponse().itemsNonProcessed) {
                  {{ FILE_UPLOAD_RESPONSE.NON_PROCESSED }} :
                  {{
                    commonUtils.fileUploadResponse().itemsNonProcessed.length
                  }}

                  <br />
                  @for (
                    val of commonUtils.fileUploadResponse().itemsNonProcessed;
                    track val
                  ) {
                    {{ val }}
                  }
                }

                @if (commonUtils.fileUploadResponse().rejected.length > 0) {
                  <br />
                  {{ FILE_UPLOAD_RESPONSE.REJECTED_ROWS }}
                  <br />
                  @for (
                    val of commonUtils.fileUploadResponse().rejected;
                    track val
                  ) {
                    {{ val }}
                  }
                  <br />
                }
              </div>

              @if (isRejectedDueToInspectArray()) {
                <div class="error-message">
                  @for (
                    line of commonUtils.fileUploadResponse()
                      .rejectedDueToInspect;
                    track line
                  ) {
                    <p>{{ line }}</p>
                  }
                </div>
              }

              @if (commonUtils.fileUploadResponse().inspectLines) {
                <div class="error-message">
                  @for (
                    line of commonUtils.fileUploadResponse().inspectLines;
                    track line
                  ) {
                    <p>{{ line }}</p>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
    <!-- FAIL BANNER-->
    @case (BANNER_MESSAGE_TYPE.FAIL) {
      <div class="fail-container" [ngClass]="{ 'nav-open': drawerOpen }">
        <div class="background-fail">
          <ion-icon class="icon-fail" [src]="IMAGES.BANNER_FAIL"></ion-icon>
          <div class="text">{{ BANNER_TYPE[bannerType()].text }}</div>

          <ion-icon
            class="icon"
            [src]="IMAGES.CLOSE_BLACK"
            alt="close"
            (click)="clickExit()"
            onkeypress="clickExit()"
          ></ion-icon>
        </div>
        @if (commonUtils.errorMessage) {
          <div class="error-message">
            <p>
              {{ commonUtils.errorMessage[0] }}
              <a [routerLink]="commonUtils.errorHref">
                {{ commonUtils.errorMessage[1] }}
              </a>
              {{ commonUtils.errorMessage[2] }}
            </p>
          </div>
        }
      </div>
    }
    <!-- GENERIC 400 BANNER-->
    @case (BANNER_MESSAGE_TYPE.FAIL_400) {
      <div class="fail-container" [ngClass]="{ 'nav-open': drawerOpen }">
        <div class="background-fail">
          <ion-icon class="icon-fail" [src]="IMAGES.BANNER_FAIL"></ion-icon>
          <div class="text">
            {{
              BANNER_TYPE[bannerType()].text.replace("%s", BANNER_400_MESSAGE())
            }}
          </div>
          <ion-icon
            class="icon"
            [src]="IMAGES.CLOSE_BLACK"
            alt="close"
            (click)="clickExit()"
            onkeypress="clickExit()"
          ></ion-icon>
        </div>
      </div>
    }
  }
</div>
